import {AuthState} from './index';

const getters = {
    IS_USER_AUTHENTICATED: (state:AuthState) => state.authenticated,
    GET_USER: (state:AuthState) => state.user,
};

export default getters;